import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AdminPanelRoutingModule } from "./admin-panel-routing.module";
import { SelectButtonModule } from "primeng/selectbutton";
import { AutoCompleteModule } from "primeng/autocomplete";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { ChartModule } from "primeng/chart";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CheckboxModule } from 'primeng/checkbox';
import { ScrollTopModule } from 'primeng/scrolltop';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { RippleModule } from "primeng/ripple";
import { TooltipModule } from 'primeng/tooltip';
import { ToolbarModule } from 'primeng/toolbar';
import { SplitButtonModule } from 'primeng/splitbutton';

import { GtagEventDirective } from "../gtag/gtag-event.directive";
import { FilterPipe } from "./filters/filter.pipe";
import { AdminPanelComponent } from "./admin-panel/admin-panel.component";
import { AdminPackageReceivedComponent } from "./admin-package-received/admin-package-received.component";
import { AdminShipmentsComponent } from "./admin-shipments/admin-shipments.component";
import { DailyStatisticComponent } from "./reporting/daily/daily.component";
import { AdminConsolidationsComponent } from "./admin-consolidations/admin-consolidations.component";
import { DailyDistributionComponent } from "./reporting/daily-distribution/daily-distribution.component";
import { ClientsDashboardComponent } from "./clients/clients-dashboard/clients-dasboard.component";
import { TrackCheckComponent } from "./clients/track-check/track-check.component";
import { TrackDeliveryComponent } from "./clients/track-delivery/track-delivery.component";
import { ClientFormComponent } from "./clients/clients-dashboard/client-form/client-form.component";
import { ResetPasswdComponent } from "./clients/clients-dashboard/reset-passwd/reset-passwd.component";
import { SelectModule } from "primeng/select";
import { DatePickerModule } from "primeng/datepicker";

@NgModule({
    imports:[
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AdminPanelRoutingModule,
        SelectButtonModule,
        DatePickerModule,
        AutoCompleteModule,
        DialogModule,
        TableModule,
        InputTextModule,
        ButtonModule,
        ChartModule,
        ProgressSpinnerModule,
        CheckboxModule,
        ScrollTopModule,
        InputGroupModule,
        InputGroupAddonModule,
        RippleModule,
        TooltipModule,
        ToolbarModule,
        SplitButtonModule,
        SelectModule,
    ],
    declarations: [
        AdminPanelComponent,
        AdminShipmentsComponent,
        AdminPackageReceivedComponent,
        AdminConsolidationsComponent,
        ClientsDashboardComponent,
        TrackDeliveryComponent,
        TrackCheckComponent,
        DailyStatisticComponent,
        DailyDistributionComponent,
        FilterPipe,
        GtagEventDirective,
        ClientFormComponent,
        ResetPasswdComponent,

    ],
})
export class AdminPanelModule {};